var consoleInfo = console.info.bind(console);
var consoleWarn = console.warn.bind(console);
var consoleError = console.error.bind(console);
var LoggerService = /** @class */ (function () {
    function LoggerService() {
    }
    LoggerService.prototype.logInfo = function (category) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        this.logIfEnabled(consoleInfo, 'info', category, args);
    };
    LoggerService.prototype.logWarn = function (category) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        this.logIfEnabled(consoleWarn, 'warn', category, args);
    };
    LoggerService.prototype.logError = function (category) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        this.logIfEnabled(consoleError, 'fail', category, args);
    };
    LoggerService.prototype.logDebug = function (category) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        this.logIfEnabled(consoleInfo, 'dbug', category, args);
    };
    LoggerService.prototype.logIfEnabled = function (func, level, category) {
        var args = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            args[_i - 3] = arguments[_i];
        }
        if (!this.isEnabled(category, level)) {
            return;
        }
        var msg = this.buildLogMessage(level, category, args);
        func(msg);
    };
    LoggerService.prototype.buildLogMessage = function (level, category) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        return [new Date().toISOString()].concat(Array.prototype.slice.call(arguments, 0)).join(' ');
    };
    return LoggerService;
}());
export { LoggerService };
